import { Component, Input, ViewChild } from '@angular/core';
import { Paginator } from 'primeng/paginator';

@Component({
  selector: 'split-paginator',
  templateUrl: './split-paginator.component.html',
  styleUrls: ['./split-paginator.component.scss']
})
export class SplitPaginatorComponent {
  @ViewChild(Paginator) paginator!: Paginator;
  @Input() first!: any;
  @Input() rows!: any;
  @Input() totalRecords!: any;

 
  nextPage() {
    this.paginator.changePage(this.paginator.getPage() + 1);
  }
  prevPage() {
    this.paginator.changePage(this.paginator.getPage() - 1);
  }
  onPageChange(event : any) {}

}
